export default __webpack_public_path__ + "static/media/Spiderman2_18.bf84423f.png";